import { Injectable, signal } from '@angular/core';
import { LANDING_CAMPAIGN_STORAGE_KEY } from '../data';
import { LandingConfigInterface } from '../types';

@Injectable()
export class LandingConfigService {
  readonly campaignId = signal<string | null>(
    sessionStorage.getItem(LANDING_CAMPAIGN_STORAGE_KEY),
  );
  readonly config = signal<LandingConfigInterface | null>(null);

  setCampaignId(campaignId: string): void {
    sessionStorage.setItem(LANDING_CAMPAIGN_STORAGE_KEY, campaignId);
    this.campaignId.set(campaignId);
  }
}
